import { Component, inject } from '@angular/core';
import {
  ExternalService as ExternalServiceService,
  ExternalServiceCreateDto,
  ExternalServiceDto,
  ExternalServiceExcelDownloadDto,
  ExternalServiceUpdateDto,
} from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { EXTERNALSERVICE_CONFIG, EXTERNALSERVICE_FIELDS } from './external-service.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-external-service',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ExternalServiceService, ConfirmationService],
  templateUrl: './external-service.html',
  styleUrl: './external-service.scss',
})
export class ExternalService extends BaseCrudComponent<
  ExternalServiceDto,
  ExternalServiceCreateDto,
  ExternalServiceUpdateDto,
  ExternalServiceExcelDownloadDto
> {
  service = inject(ExternalServiceService);
  config = EXTERNALSERVICE_CONFIG;
  fields = EXTERNALSERVICE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ExternalServiceDto): ExternalServiceUpdateDto {
    return {
      name: data.name,
      description: data.description,
      isActive: data.isActive,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ExternalService';
  }
}
